import React from 'react';
import './agreement.less';

export function Title() {
    return <div className='head'>用户协议</div>
}

export function Passage0() {
    return <div className='page'>
        欢迎您使用AI教育资源云平台。本软件最终用户协议（“本协议”）是您（“用户”）和深圳果力智能科技有限公司（“服务商”）之间，就服务商为您提供AI教育资源云平台（“本软件”），所达成的合法协议。
    </div>
}

export function Passage1() {
    return <div className='page'>
        <div className='title'>一、协议的生效</div>
        <div>1、用户确认而生效：本协议由服务商提供在线版本，用户购买本软件时，应认真阅读本协议。本协议一经用户确认，即具有合同效力，对服务商和用户具有法律约束力。</div>
        <div>2、用户使用而生效：用户可以通过SaaS账户登录的方式使用本软件。服务商会在相应环节提供本协议的在线版本供用户阅读。一旦用户以前述任何一种方式使用本软件，即表示用户已同意接受本协议中的所有条款。如果用户不接受本协议中的条款，请不要使用本软件。</div>
    </div>
}

export function Passage2() {
    return <div className='page'>
        <div className='title'>二、使用许可</div>
        <div>1、本软件受版权法、国际版权条约以及其他相关的知识产权法律、法规和条约的保护。本软件产品|服务为授权用户使用许可，而非出售。</div>
        <div>2、本软件的版权及所有权归深圳果力智能科技有限公司所有。</div>
        <div>3、根据本协议的约定，服务商授予用户一项非排他的、不可转让的使用本软件的使用许可。用户不得转售或以其他方式转让本使用许可权利以及本软件中的任何资源以牟取商业利益。</div>
    </div>
}

export function Passage3() {
    return <div className='page'>
        <div className='title'>三、费用</div>
        <div>1、用户使用本软件须按照本软件的价格体系、支付所有费用。服务商保留在用户未按照约定支付全部费用之前不向用户提供服务和|或技术支持，或者终止服务和|或技术支持的权利。</div>
        <div>2、用户如对本软件进行续费时，本软件的名称、规格或价格已经调整的，用户同意按照届时有效的新的软件的名称、规格或价格履行；用户不同意新的软件的名称、规格或价格的，可不进行续费，本软件到期后自动终止。</div>
    </div>
}

export function Passage4() {
    return <div className='page'>
        <div className='title'>四、用户的权利义务</div>
        <div>1、用户保证其使用本软件的各项行为均符合国家法律法规的规定，合法真实且不侵害任何第三方的合法权益。</div>
        <div>2、用户应按时足额支付本软件的费用（如有），否则服务商保留随时终止用户使用本软件的权利，用户应对服务商终止本软件而可能造成的损害自行承担全部责任。</div>
        <div>3、用户保证，除且仅除法律明确允许的活动以外，用户不得逆向工程、反编译或反汇编本软件。</div>
        <div>4、用户理解并同意， 因现有技术限制，服务商提供的软件可能存在瑕疵，并不能保证在任何情况下都能正常执行或达到用户所期望的结果。</div>
    </div>
}

export function Passage5() {
    return <div className='page'>
        <div className='title'>五、服务商的权利义务</div>
        <div>1、服务商保证，其有合法权利向用户提供本软件的使用许可，并保证其版权的合法性。</div>
        <div>2、服务商承诺，其向用户提供本软件之行为未对任何第三方合法权益，包括但不限于第三方知识产权构成侵害。如因其行为导致用户遭受任何第三方提起的法律诉讼或行政程序（“侵权指控”），服务商承担其法律责任及后果。</div>
        <div>3、服务商负责及时对本软件进行升级、维护和管理，并通过客服电话、在线客服等方式，向用户提供免费的咨询及技术支持服务。</div>
        <div>4、服务商承诺，保证其为用户提供的软件的稳定性和延续性。如因服务商原因，导致用户对于本软件的使用许可需提前终止的，服务商应对用户履行相应的退款义务（如有）。</div>
        <div>5、服务商承诺，其向用户提供的软件中不含有：
            <div className='child'>（1）蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序；</div>
            <div className='child'>（2）任何已知的漏洞、后门、恶意软件；</div>
            <div className='child'>（3）其他可能对用户的系统安全造成损害的不安全内容。</div>
        </div>
        <div>6、责任限制：在适用法律所允许的最大范围内，服务商不会对因使用或不能使用本软件所引起的或有关的任何间接的、意外的、直接的、特殊的、惩罚性的或其它任何损害（包括但不限于因人身伤害或财产损坏而造成的损害，因利润损失、数据损失、营业中断、计算机瘫痪或故障、商业信息的遗失而造成的损害，因未能履行包括诚信或相当注意在内的任何责任致使隐私泄露而造成的损害，因疏忽而造成的损害，或因任何金钱上的损失或任何其它损失而造成的损害）承担赔偿责任，即使服务商事先被告知该损害发生的可能性。</div>
    </div>
}
export function Passage6() {
    return <div className='page'>
        <div className='title'>六、用户数据的使用和披露</div>
        <div>1、为服务用户的目的，服务商可能通过使用用户数据，向用户提供服务，包括但不限于向用户发出产品和服务信息。</div>
        <div>2、未经用户许可，服务商不会擅自披露用户数据。但在下述情况下，用户数据将部分或全部被披露：
            <div className='child'>（1）经用户同意，向第三方披露；</div>
            <div className='child'>（2）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构 披露；</div>
            <div className='child'>（3）如果用户出现违反中国有关法律法规的情况，需要向第三方披露；</div>
            <div className='child'>（4）为提供用户所要求的软件或服务，而必须和第三方分享用户数据；</div>
        </div>
    </div>
}
export function Passage7() {
    return <div className='page'>
        <div className='title'>七、期限与终止</div>
        <div>1、本软件的期限为12月或36月，以用户购买的产品周期为准。</div>
        <div>2、出现下列情况之一的，服务商有权终止继续提供本软件，而无需承担任何责任：
            <div className='child'>（1）用户购买的软件已到期且未续费的；</div>
            <div className='child'>（2）用户严重违反本协议项下条款的约定，且自服务商通知其纠正后仍未纠正的；</div>
        </div>
    </div>
}
export function Passage8() {
    return <div className='page'>
        <div className='title'>八、协议修改</div>
        <div>1、如果本协议的任何内容发生变动，服务商应通过适当方式向用户提示修改内容。</div>
        <div>2、如果用户不同意服务商对本协议相关条款所做的修改，用户有权停止使用本软件此等情况下，服务商应向用户退回剩余费用（如有），并在终止服务前给予用户一定的合理期限，进行数据备份、下载、保存、迁移及其他必要工作。如用户继续使用本软件，则视为用户接受服务商对本协议相关条款所做的修改。</div>
    </div>
}
export function Passage9() {
    return <div className='page'>
        <div className='title'>九、法律及争议解决</div>
        <div>1、本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</div>
        <div>2、因双方就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均应向被告所在地人民法院起诉。</div>
    </div>
}

export function Passage10() {
    return <div className='page'>
        <div className='title'>十、附则</div>
        <div>1、如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部分则仍具有法律效力。</div>
        <div>2、本协议的标题仅为方便阅读所设，非对条款的定义、限制、解释或描述其范围或界限。 </div>
        <div>3、服务商可根据其自身运营状况，在提前30个工作日通知用户的前提下，将其在本协议项下的权利义务全部转让给第三方，而无需获得用户的事先同意。服务商之受让人受本协议约束，服务商与其受让人对本协议的履行承担连带责任。</div>
    </div>
}

// 用户协议    公共组件   在 注册账号页，用户中心>用户协议 引用了
const AgreementCom = () => {
    return (
        <div className='agreement'>
            <Title />
            <Passage0 />
            <Passage1 />
            <Passage2 />
            <Passage3 />
            <Passage4 />
            <Passage5 />
            <Passage6 />
            <Passage7 />
            <Passage8 />
            <Passage9 />
            <Passage10 />
        </div>
    )
}

export default AgreementCom;